import '../Home/Home.css';
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import withNavigateHook from '../../myRoutes';
import React, { Component } from "react";
import DatePicker from "react-datepicker";
import { redirect } from 'next/dist/server/api-utils';
class Menu extends React.Component {
    constructor(props) {
        super(props);
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        const dateWithoutSecond = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: '2-digit', minute: '2-digit' });
        const dateTime = new Date().toLocaleDateString('en-uk', { hour: '2-digit', minute: '2-digit' });
        this.state = {
            date: today,
            dateWithoutSecond: dateWithoutSecond,
            dateTime: dateTime,
            userRole: "",
            db: "",
            email: "",
            firstname: "",
            redirect: "",
            memberstatus: "",
            showPrompt: false

        }
    }

    componentDidMount = () => {
        //  console.log(typeof this.props.location)
        // if ((this.state.db ==="")|| (this.state.email ==="")||
        // (this.state.firstname ==="") || (this.state.userRole==="")){
        // console.log(typeof this.props.location.db)
        if ((typeof this.props.location !== 'object')) {
            // console.log('I am here');
            this.setState({ redirect: 'redirect' })
            //this.appLogout();
        }
        else {
            this.setState({
                db: this.props.location.state.db, firstname: this.props.location.state.firstname,
                email: this.props.location.state.email, userRole: this.props.location.state.userRole, memberStatus: this.props.location.state.ms
            });

            if (this.props.location.state.userRole === 'user') {
                document.getElementById('caseManagementDiv').style.display = 'none';
                document.getElementById('userManagementDiv').style.display = 'none';
                //return 'block';
            }
            if (this.props.location.state.memberstatus !== 'Approved') {
                document.getElementById('caseManagementDiv').style.display = 'none';
                document.getElementById('userManagementDiv').style.display = 'none';                
                document.getElementById('memberDiv').style.display = 'none';
                document.getElementById('myCaseDiv').style.display = 'none';
                document.getElementById('caseReportsDiv').style.display = 'none';
                document.getElementById('updateCaseDiv').style.display = 'none';
                //return 'block';
            }
            if ((this.props.location.state.memberstatus === 'Approved') &&(this.props.location.state.userRole === 'user')){
                document.getElementById('caseManagementDiv').style.display = 'none';
                document.getElementById('userManagementDiv').style.display = 'none';                          
                document.getElementById('myCaseDiv').style.display = 'block';
                document.getElementById('caseReportsDiv').style.display = 'block';
                document.getElementById('updateCaseDiv').style.display = 'none';
                //return 'block';
            }
            
        }
    }

    componentDidUpdate() {
        window.onpopstate = e => {
            if (window.confirm('Are you sure you want to log out?')) {
                this.appLogout();
            } else {
                this.props.navigate('/menu', {
                    state: {
                        db: this.state.db, email: this.state.email,
                        firstname: this.state.firstname, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
                    }
                });
            }
        }
    }

    appLogout = (e) => {
        // e.preventDefault();
        this.props.navigate('/', { state: { db: '', email: '', firstname: '', userRole: "" } });

    }
    goToRegistrations = (e) => {
        e.preventDefault();
        this.props.navigate('/home', {
            state: {
                db: this.state.db, email: this.state.email,
                firstname: this.state.firstname, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
            }
        });
    }
    goToMembers = (e) => {
        e.preventDefault();
        this.props.navigate('/registrations', {
            state: {
                db: this.state.db, email: this.state.email,
                firstname: this.state.firstname, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
            }
        });
    }
    goToCases = (e) => {
        e.preventDefault();
        this.props.navigate('/cases', {
            state: {
                db: this.state.db, email: this.state.email,
                firstname: this.state.firstname, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
            }
        });
    }

    goToCaseReports = (e) => {
        e.preventDefault();
        this.props.navigate('/casereports', {
            state: {
                db: this.state.db, email: this.state.email,
                firstname: this.state.firstname, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
            }
        });
    }


    goToMyCases = (e) => {
        e.preventDefault();
        this.props.navigate('/mycases', {
            state: {
                db: this.state.db, email: this.state.email,
                firstname: this.state.firstname, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
            }
        });
    }
    goToUpdateCases = (e) => {
        e.preventDefault();
        this.props.navigate('/updatecases', {
            state: {
                db: this.state.db, email: this.state.email,
                firstname: this.state.firstname, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
            }
        });
    }



    render() {

        if ((this.state.redirect === 'redirect') || (typeof this.props.location !== 'object')) {
            return (
                // console.log('here now>>>')
                // <div><span><label>Redirect</label></span></div>
                this.props.navigate('/', { state: { db: '', email: '', firstname: '', userRole: "" } })
            )
        }
        else {

            return (
                <body >
                    <div className='mainDivHome' style={{ paddingTop: "15vh", border: '2px solid rgb(89, 100, 95)', borderRadius:"10px" }}>
                        <div style={{ paddingTop: "10px", paddingBottom: "10px", textAlign: "center" }}>
                            <span style={{ fontStyle: "italic" }} className="businessname"><h4>{this.props.location.state.db}</h4></span>
                            <span style={{ fontStyle: "italic" }}><label>Welcome {this.props.location.state.firstname}</label></span>
                            <span style={{ fontStyle: "italic" }}><label>, today is {this.state.date}</label></span>
                        </div>

                        <div id='memberDiv' >
                            <Button style={{ paddingLeft: "5px", width: "100%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", color: "white", fontSize: "18px", fontStyle: "italic" }} text="Member Management" onClick={this.goToMembers}>Member Management</Button>
                        </div>
                        <div id='caseManagementDiv' style={{ paddingTop: "10px" }}>
                            <Button style={{ paddingLeft: "5px", width: "100%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", color: "white", fontSize: "18px", fontStyle: "italic" }} text="Case Management" onClick={this.goToCases}>Case Management</Button>
                        </div>
                        <div id='userManagementDiv' style={{ paddingTop: "10px" }}>
                            <Button style={{ paddingLeft: "5px", width: "100%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", color: "white", fontSize: "18px", fontStyle: "italic" }} text="User Management">User Management</Button>
                        </div>
                        <div id='caseReportsDiv' style={{ paddingTop: "10px" }}>
                            <Button style={{ paddingLeft: "5px", width: "100%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", color: "white", fontSize: "18px", fontStyle: "italic" }} text="Case Reports" onClick={this.goToCaseReports}>Case Reports</Button>
                        </div>
                        <div id='registrationsDiv' style={{ paddingTop: "10px" }}>
                            <Button style={{ paddingLeft: "5px", width: "100%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", color: "white", fontSize: "18px", fontStyle: "italic" }} text="Member Registration" onClick={this.goToRegistrations}>Registrations</Button>
                        </div>
                        <div id='updateCaseDiv' style={{ paddingTop: "10px" }}>
                            <Button style={{ paddingLeft: "5px", width: "100%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", color: "white", fontSize: "18px", fontStyle: "italic" }} text="Update Cases" onClick={this.goToUpdateCases}>Update Cases</Button>
                        </div>
                        <div id='myCaseDiv' style={{ paddingTop: "10px" }}>
                            <Button style={{ paddingLeft: "5px", width: "100%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", color: "white", fontSize: "18px", fontStyle: "italic" }} text="My Cases" onClick={this.goToMyCases}>My Cases</Button>
                        </div>                        
                        <div id='logoutDiv' style={{ paddingTop: "10px" }}>
                            <Button style={{ paddingLeft: "5px", width: "100%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", color: "#ff7400", fontSize: "18px", fontStyle: "italic" }} text="Logout" onClick={this.appLogout}>Logout</Button>
                        </div>
                    </div></body>)
        }
    }
}
export default withNavigateHook(Menu);